// models

export interface TaxValidationConfig {
  countryCode: string;
  validationEnabled: boolean;
  minLength: number;
  maxLength: number;
  numericOnly: boolean;
  errorMessage: string;
}

export interface TaxValidationResult {
  valid: boolean;
  message?: string;
}

// functions

export function validateTaxRegistration(
  value: string,
  config?: TaxValidationConfig,
  isMY?: boolean,
  isKtp?: boolean
): TaxValidationResult {
  const defaultEmptyMessage = isKtp ? "Masukan nomor KTP" : "Masukan Nomor NPWP";

  if (config && config.validationEnabled) {
    if (!value) {
      return {
        valid: false,
        message: defaultEmptyMessage
      };
    }

    const isNumberOnly = (val: string): boolean => /^\d+$/.test(val);

    if (config.numericOnly && !isNumberOnly(value)) {
      return {
        valid: false,
        message: config.errorMessage || defaultEmptyMessage
      };
    }

    const isLengthValid =
      config.maxLength === 0
        ? value.length >= config.minLength
        : value.length >= config.minLength && value.length <= config.maxLength;

    if (!isLengthValid) {
      return {
        valid: false,
        message: config.errorMessage || defaultEmptyMessage
      };
    }

    return { valid: true };
  }

  if (isKtp) {
    if (!value) {
      return {
        valid: false,
        message: defaultEmptyMessage
      };
    }
    if (isMY) {
      const isValid = /^[a-zA-Z0-9]+$/.test(value) && value.length === 16;
      return {
        valid: isValid,
        message: defaultEmptyMessage
      };
    }
    const isValid = /^\d+$/.test(value) && value.length >= 15 && value.length <= 16;
    return {
      valid: isValid,
      message: defaultEmptyMessage
    };
  }

  // Fallback validation when Unleash is disabled or config is not found
  if (!value) {
    return {
      valid: false,
      message: defaultEmptyMessage
    };
  }

  if (isMY) {
    const targetLength = 16;
    const isValid =
      /^[a-zA-Z0-9]+$/.test(value) && value.length === targetLength;
    return {
      valid: isValid,
      message: defaultEmptyMessage
    };
  }

  // Default fallback for ID (Indonesia)
  const isNumeric = /^\d+$/.test(value);
  const isValid = isNumeric && value.length >= 15 && value.length <= 16;

  return {
    valid: isValid,
    message: defaultEmptyMessage
  };
}
